// Cash fund category URL path segments eligible for the honeymoon pitch dialog.
// Matched against the trailing segment of selectedCategory.publicUrlPath.
const HONEYMOON_ELIGIBLE_CATEGORY_SLUGS = ['honeymoon', 'cash-travel'];

export const isHoneymoonRelatedCategory = (publicUrlPath: string | undefined | null): boolean => {
  if (!publicUrlPath) return false;
  const slug = publicUrlPath.split('/').pop()?.toLowerCase();
  return !!slug && HONEYMOON_ELIGIBLE_CATEGORY_SLUGS.includes(slug);
};
